export default "__VITE_ASSET__BatfkG0p__"